import { Controller } from 'stimulus'
import { setTransitionHooks } from 'vue'

export default class extends Controller {
  static targets = ['toDisable']

  connect() {
    this.form = this.element
    this.submitting = false
    this._setListeners()
  }

  submit() {
    if (this.submitting) { return }

    this._disable()
    this.form.requestSubmit()
  }

  _setListeners() {
    this.form.addEventListener('turbo:submit-end', () => {
      this._enable()
    })
  }

  _disable() {
    this.submitting = true

    if (!this.hasToDisableTargets) { return }

    this.toDisableTargets.forEach(input => {
      input.setAttribite('disabled', 'true')
    })
  }

  _enable() {
    this.submitting = false

    if (!this.hasToDisableTargets) { return }

    this.toDisableTargets.forEach(input => {
      input.removeAttribite('disabled')
    })
  }
}
